module.exports = __webpack_public_path__ + "img/add_icon_af.699874ab.svg";